import {
    cibBehance,
    cibCcAmex,
    cibCcMastercard,
    cibCcVisa,
    cibDribbble,
    cibFacebook,
    cibFlickr,
    cibGithub,
    cibGooglePay,
    cibInstagram,
    cibLinkedin,
    cibPaypal,
    cibPinterest,
    cibReddit,
    cibSkype,
    cibStackoverflow,
    cibStripe,
    cibTumblr,
    cibTwitter,
    cibVimeo,
    cibVk,
    cibXing,
    cibYahoo,
    cibYoutube,
    cifBr,
    cifEs,
    cifFr,
    cifIn,
    cifPl,
    cifUs,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowCircleBottom,
    cilArrowCircleTop,
    cilArrowRight,
    cilArrowTop,
    cilAsterisk,
    cilBadge,
    cilBan,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilCalculator,
    cilCalendar,
    cilCasino,
    cilChartLine,
    cilChartPie,
    cilCheck,
    cilCheckCircle,
    cilChevronBottom,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCircle,
    cilCloudDownload,
    cilCode,
    cilCog,
    cilCommentSquare,
    cilCreditCard,
    cilCursor,
    cilCursorMove,
    cilDiamond,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeLetter,
    cilEnvelopeOpen,
    cilEthernet,
    cilEuro,
    cilExternalLink,
    cilFile,
    cilFullscreen,
    cilFullscreenExit,
    cilGamepad,
    cilGlobeAlt,
    cilGraph,
    cilGrid,
    cilHistory,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInputPower,
    cilItalic,
    cilJustifyCenter,
    cilJustifyLeft,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilListNumbered,
    cilListRich,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMemory,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperclip,
    cilPaperPlane,
    cilPencil,
    cilPeople,
    cilPhone,
    cilPrint,
    cilPuzzle,
    cilSave,
    cilScrubber,
    cilSend,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSun,
    cilTags,
    cilTask,
    cilTerminal,
    cilTranslate,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserUnfollow,
    cilWarning,
    cilX,
    cilXCircle,
    cilZoom,
} from '@coreui/icons'

import { sygnet } from './sygnet'
import { TT_logo } from './TT_logo'

export const icons = Object.assign(
    {},
    {
        TT_logo,
        sygnet,
    },
    {
        cilAlignCenter,
        cilAlignLeft,
        cilAlignRight,
        cilApplicationsSettings,
        cilArrowRight,
        cilArrowTop,
        cilAsterisk,
        cilBan,
        cilBasket,
        cilBell,
        cilBold,
        cilBookmark,
        cilCalculator,
        cilCalendar,
        cilCloudDownload,
        cilChartPie,
        cilCheck,
        cilChevronBottom,
        cilChevronLeft,
        cilChevronRight,
        cilChevronTop,
        cilCircle,
        cilCheckCircle,
        cilCode,
        cilCommentSquare,
        cilCreditCard,
        cilCursor,
        cilCursorMove,
        cilDrop,
        cilDollar,
        cilEnvelopeClosed,
        cilEnvelopeLetter,
        cilEnvelopeOpen,
        cilEuro,
        cilGlobeAlt,
        cilGrid,
        cilFile,
        cilFullscreen,
        cilFullscreenExit,
        cilGraph,
        cilHome,
        cilInbox,
        cilIndentDecrease,
        cilIndentIncrease,
        cilInputPower,
        cilItalic,
        cilJustifyCenter,
        cilJustifyLeft,
        cilLaptop,
        cilLayers,
        cilLightbulb,
        cilList,
        cilListNumbered,
        cilListRich,
        cilLocationPin,
        cilLockLocked,
        cilMagnifyingGlass,
        cilMap,
        cilMoon,
        cilNotes,
        cilOptions,
        cilPaperclip,
        cilPaperPlane,
        cilPencil,
        cilPeople,
        cilPhone,
        cilPrint,
        cilPuzzle,
        cilSave,
        cilScrubber,
        cilSettings,
        cilShare,
        cilShareAll,
        cilShareBoxed,
        cilShieldAlt,
        cilSpeech,
        cilSpeedometer,
        cilSpreadsheet,
        cilStar,
        cilSun,
        cilTags,
        cilTask,
        cilTranslate,
        cilTrash,
        cilUnderline,
        cilUser,
        cilUserFemale,
        cilUserFollow,
        cilUserUnfollow,
        cilX,
        cilXCircle,
        cilWarning,
        cilGamepad,
        cilCasino,
        cilTerminal,
        cilMemory,
        cilHistory,
        cilExternalLink,
        cilEthernet,
        cilChartLine,
        cilArrowCircleBottom,
        cilArrowCircleTop,
        cilCog,
        cilDiamond,
        cilBadge,
        cilSend,
        cilZoom,
    },
    {
        cifUs,
        cifBr,
        cifIn,
        cifFr,
        cifEs,
        cifPl,
    },
    {
        cibSkype,
        cibFacebook,
        cibTwitter,
        cibLinkedin,
        cibFlickr,
        cibTumblr,
        cibXing,
        cibGithub,
        cibStackoverflow,
        cibYoutube,
        cibDribbble,
        cibInstagram,
        cibPinterest,
        cibVk,
        cibYahoo,
        cibBehance,
        cibReddit,
        cibVimeo,
        cibCcMastercard,
        cibCcVisa,
        cibStripe,
        cibPaypal,
        cibGooglePay,
        cibCcAmex,
    }
)
